import render from './render'

export default {
  name: 'Readonly',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  render
}
